// extracted by mini-css-extract-plugin
module.exports = {"root":"GptAd_root__2eqVh"};